import { render, staticRenderFns } from "./AdminPackagingCodes.vue?vue&type=template&id=267164de&scoped=true&"
import script from "./AdminPackagingCodes.vue?vue&type=script&lang=js&"
export * from "./AdminPackagingCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267164de",
  null
  
)

export default component.exports